import { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import RoutesTae from './router-dom/RoutesTae';
import {
  BrowserRouter as Router,
  useLocation
} from "react-router-dom";
import SideBarPro from './router-dom/SideBarPro';



function App() {
  const [autenticado, SetAutenticado] = useState(false);
  const [adminTae, setAdminTae] = useState(false);

  useEffect(() => {
    const SesionFin = localStorage.getItem('tokenSesionFin');
    setAdminTae(localStorage.getItem('AdminTae') === 'true' ? true : false);

    if (SesionFin !== null) {
      const FechaFin = new Date(SesionFin);
      if (FechaFin >= new Date()) {
        // console.log('Session ok');
        SetAutenticado(true);
      }
      else {
        alert('Tu sesión expiro, por favor ingresa de nuevo');
        SetAutenticado(false);
        localStorage.clear();
        window.location.href = '/';
      }
    }
  }, [])

  return (
    <div style={{ display: "flex", height: '100%' }}>
      <Router>
        {autenticado === true ?
          <SideBarPro
            AdminTae={adminTae}
          />
          : null}


        <main>
          <RoutesTae
            Autenticado={autenticado}
          />
        </main>
      </Router>
    </div>
  );
}

export default App;
